import { render, staticRenderFns } from "./EditLov.vue?vue&type=template&id=134e60ce&scoped=true&"
import script from "./EditLov.vue?vue&type=script&lang=ts&"
export * from "./EditLov.vue?vue&type=script&lang=ts&"
import style0 from "./EditLov.vue?vue&type=style&index=0&id=134e60ce&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "134e60ce",
  null
  
)

export default component.exports